import type { GridCoordinate } from "../domain/types";
import type { MultiplayerMode } from "./multiplayer-protocol";

export type BattlefieldSide = "left" | "right";

export interface MultiplayerBattleContext {
  readonly mode: MultiplayerMode;
  readonly localPlayerId: string;
  readonly localSide: BattlefieldSide;
  readonly playerIds: readonly string[];
  readonly isHost: boolean;
}

export const SENDABLE_ENEMIES = Object.freeze({
  footman: { cost: 45, label: "Footman" },
  scout: { cost: 70, label: "Scout" },
  brute: { cost: 125, label: "Brute" },
  knight: { cost: 190, label: "Knight" },
});

export function sideForSlot(slot: number): BattlefieldSide {
  return slot === 0 ? "left" : "right";
}

export function sideForCell(cell: GridCoordinate, mapWidth: number): BattlefieldSide {
  return cell.x < mapWidth / 2 ? "left" : "right";
}

export function canDeployOnCell(
  context: MultiplayerBattleContext,
  cell: GridCoordinate,
  mapWidth: number,
): boolean {
  return sideForCell(cell, mapWidth) === context.localSide;
}

/** In head-to-head, a side's towers defend against units entering from the opposite gate. */
export function towerMayTargetSpawnSide(
  mode: MultiplayerMode,
  towerSide: BattlefieldSide,
  enemySpawnSide: BattlefieldSide,
): boolean {
  return mode === "coop" || towerSide !== enemySpawnSide;
}
